var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCylinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60 31.8c0 15.4-12.6 28-28 28s-28-12.6-28-28 12.6-28 28-28 28 12.6 28 28z",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6 35.8v13.8c0 2.4-2 4.6-4.6 4.6h-2.2c-2.4 0-4.6-2-4.6-4.6v-13.8",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 23.4c0 7.8-6.2 14-14 14s-14-6.2-14-14 6.2-14 14-14 14 6.2 14 14z",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 14.4v4l2.8 2.8-2.8 2.8v8.4",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinder);
export default __webpack_public_path__ + "static/media/cylinder.a31fc084450da001e1201e490afa651b.svg";
export { ForwardRef as ReactComponent };